module.exports = __webpack_public_path__ + "img/dloons_03.07965c47.png";